import { useState } from 'react';

import AttendanceUsers from './AttendanceUsers';
import { TabsUI } from '../Interface';
import ExcelImportTab from '../Interface/ExcelImportTab';

const AttendanceTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Tétel',
      content: <AttendanceUsers {...props} />,
    },
    {
      id: 1,
      name: 'Adat import',
      content: <ExcelImportTab {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default AttendanceTabs;
